import React, { ReactNode } from 'react';

import * as styles from './EmptyState.module.scss';

type Props = {
  headingText: string;
  subHeadingText: string;
  centerContent: ReactNode;
  actionableContent: ReactNode;
  className?: string;
  ['data-testid']?: string;
};

const EmptyState: React.FC<Props> = ({
  actionableContent,
  centerContent,
  headingText,
  subHeadingText,
  className = '',
  ['data-testid']: testId = '',
}) => {
  return (
    <div
      className={`${styles.wrapper} flexCenter ${className}`}
      data-testid={testId}
    >
      <h2 className="heading2">{headingText}</h2>
      {centerContent}
      <p className="subHeading">{subHeadingText}</p>
      {actionableContent}
    </div>
  );
};

export default EmptyState;
